import { environment } from 'src/environments/environment';

export function getBaseUrl(): string {
  return environment.API_BASE_URL + '/';
}
